//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum UploadQueueStatus {
  Failed = 'Failed',
  Idle = 'Idle',
  Success = 'Success',
  Uploading = 'Uploading',
}

export interface IUploadQueueState {
  queuedItemIds: string[];
  status: UploadQueueStatus;
}
